import React, { useMemo } from 'react';
import styled from "styled-components";
import { useSelector } from "react-redux";
import { selectAllWhereaboutsOptions } from '@features/whereabouts/store/whereaboutsOptions.duck';
import { FixedWhereabouts, WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import { CustomWhereaboutsOption } from "./CustomWhereaboutsOption";
import { selectIconPack } from "@shared/store/auth.duck";
import { naturalComparator } from '@shared/utils/ArrayUtils';

function isEditableDefaultWhereabouts(option: WhereaboutsOption) {
  return option.key === FixedWhereabouts.Office ||
    option.key === FixedWhereabouts.Home ||
    option.key === FixedWhereabouts.NotWorking
}

export function DefaultWhereaboutsList(props: Props) {
  const customWhereabouts = useSelector(selectAllWhereaboutsOptions);
  const iconPack = useSelector(selectIconPack)

  const sortedAndFilteredWhereaboutsList = useMemo(() => {
    if (customWhereabouts.length > 0) {
      const filteredWhereabouts = customWhereabouts
        .filter(cw => cw.required)
        .filter(cw => isEditableDefaultWhereabouts(cw));

      return [...filteredWhereabouts].sort(function(a, b) {
          if (a.colour === b.colour) {
            return naturalComparator(a, b, 'label');
          }
          return naturalComparator(a, b, 'colour');
        });
    } else {
      return [];
    }
  }, [customWhereabouts]);

  return (
    <Container>
      {sortedAndFilteredWhereaboutsList.map((cw: WhereaboutsOption, key) => <>
        <CustomWhereaboutsOption key={key}
                                 isDefaultWhereabouts={true}
                                 iconPack={iconPack}
                                 customWhereabouts={cw} />
      </>)}
    </Container>
  )
}

interface Props {
}


const Container = styled.div`
  margin-bottom: 24px;
`
